import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

// StrictMode double-mounts effects in dev, which starts two memory-hard PoW
// solvers on the main thread and both miss the live MEDIUM deadline. Off for
// local live-API testing; re-enable when exercising the mock path.
createRoot(document.getElementById("root")!).render(<App />);
